import { IdmeTokenResponse, IdmeAuthService } from 'common/api';

export async function idMeLoginApi(params: {
  authorizationCode: string;
}): Promise<IdmeTokenResponse> {
  const response: IdmeTokenResponse =
    await IdmeAuthService.idmeAuthControllerExchangeCodeForToken(params);

  return {
    id_token: response.id_token,
    refresh_token: response.refresh_token,
  };
}
